var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "contactModal",
          staticClass: "contact-modal-wrapper",
          attrs: {
            size: "lg",
            "hide-header": "",
            "hide-footer": "",
            "header-class": "contact-modal-header",
            "body-class": "p-0",
          },
          on: { hidden: _vm.clearData },
        },
        [
          _c("div", { staticClass: "contact-container d-flex" }, [
            _c(
              "div",
              {
                staticClass:
                  "contact-header w-100 px-4 pt-2 pb-2 d-flex d-md-none justify-content-between align-items-center",
              },
              [
                _c("h5", { staticClass: "mb-0 contact-name" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        `${_vm.record.first_name || ""} ${
                          _vm.record.last_name || ""
                        }`
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "contact-actions d-flex" }, [
                  "id" in _vm.record
                    ? _c(
                        "span",
                        {
                          staticClass: "modal-btn action-btn",
                          on: { click: _vm.editContact },
                        },
                        [
                          _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Save Profile",
                                expression: "'Save Profile'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "update-contact fi-save nav-icon",
                          }),
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "modal-btn action-btn",
                          on: { click: _vm.createGuest },
                        },
                        [
                          _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Save Profile",
                                expression: "'Save Profile'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "create-contact fi-save nav-icon",
                          }),
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "modal-btn action-btn",
                      on: { click: _vm.hide },
                    },
                    [
                      _c("i", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.top",
                            value: "Close Window",
                            expression: "'Close Window'",
                            modifiers: { hover: true, top: true },
                          },
                        ],
                        staticClass: "cancel-contact fi-x nav-icon",
                      }),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "contact-sidenav d-none d-md-flex" }, [
              _c("div", { staticClass: "sidenav-header mb-4" }, [
                _c("div", { staticClass: "nav-section-title text-center" }, [
                  _c("div", { staticClass: "contact-avatar mx-auto mb-2" }, [
                    _vm.record.photo_uri
                      ? _c("img", {
                          staticClass: "avatar-img",
                          attrs: {
                            src: _vm.record.photo_uri,
                            alt: "Contact photo",
                          },
                        })
                      : _c(
                          "div",
                          {
                            staticClass:
                              "avatar-placeholder d-flex align-items-center justify-content-center",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getInitials) +
                                "\n              "
                            ),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fi-person-circle sidenav-icon" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "contact-nav-items" },
                _vm._l(_vm.sections, function (section, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "contact-nav-item",
                      class: { active: _vm.activeSection === section.id },
                      on: {
                        click: function ($event) {
                          return _vm.scrollToSection(section.id)
                        },
                      },
                    },
                    [
                      _c("i", { class: section.icon }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(section.title)),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticStyle: { display: "none" },
                attrs: { type: "file" },
                on: { change: _vm.onFileChanged },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "contactContent",
                staticClass: "contact-content",
                on: { scroll: _vm.handleScroll },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "desktop-header px-4 pt-2 pb-2 d-none d-md-flex justify-content-between align-items-center",
                  },
                  [
                    _c("h5", { staticClass: "mb-0 contact-name" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            `${_vm.record.first_name || ""} ${
                              _vm.record.last_name || ""
                            }`
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "contact-actions d-flex" }, [
                      "id" in _vm.record
                        ? _c(
                            "span",
                            {
                              staticClass: "modal-btn action-btn",
                              on: { click: _vm.editContact },
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: "Save Profile",
                                    expression: "'Save Profile'",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                staticClass: "update-contact fi-save nav-icon",
                              }),
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "modal-btn action-btn",
                              on: { click: _vm.createGuest },
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: "Save Profile",
                                    expression: "'Save Profile'",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                staticClass: "create-contact fi-save nav-icon",
                              }),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "modal-btn action-btn",
                          on: { click: _vm.hide },
                        },
                        [
                          _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Close Window",
                                expression: "'Close Window'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "cancel-contact fi-x nav-icon",
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contact-body px-4" },
                  [
                    _c(
                      "b-card",
                      {
                        ref: "profile",
                        staticClass: "mb-3 section-card",
                        attrs: { "no-body": "", id: "profile" },
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-2 border-bottom-0 text-left",
                            attrs: { "header-tag": "header", role: "tab" },
                          },
                          [
                            _c("i", { staticClass: "fi-torso mr-2" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("contact_modal.profile_title")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.first"
                                              ),
                                              "label-for": "NameInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "NameInput",
                                                type: "text",
                                              },
                                              model: {
                                                value: _vm.record.first_name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "first_name",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.first_name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.middle"
                                              ),
                                              "label-for": "MiddleNameInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "MiddleNameInput",
                                                type: "text",
                                              },
                                              model: {
                                                value: _vm.record.middle_name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "middle_name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "record.middle_name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label:
                                                _vm.$t("contact_modal.last"),
                                              "label-for": "LastNameInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "LastNameInput",
                                                type: "text",
                                              },
                                              model: {
                                                value: _vm.record.last_name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "last_name",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.last_name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.birthday"
                                              ),
                                              "label-for": "BirthdayInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "BirthdayInput",
                                                type: "date",
                                              },
                                              model: {
                                                value: _vm.record.birthday,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "birthday",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.birthday",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.country"
                                              ),
                                              "label-for": "CountryInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "CountryInput",
                                                type: "text",
                                              },
                                              model: {
                                                value:
                                                  _vm.record.country_of_origin,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "country_of_origin",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "record.country_of_origin",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.citizenship"
                                              ),
                                              "label-for": "CitizenshipInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "CitizenshipInput",
                                                type: "text",
                                              },
                                              model: {
                                                value: _vm.record.citizenship,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "citizenship",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "record.citizenship",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        ref: "contact",
                        staticClass: "mb-3 section-card",
                        attrs: { "no-body": "", id: "contact" },
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-2 border-bottom-0 text-left",
                            attrs: { "header-tag": "header", role: "tab" },
                          },
                          [
                            _c("i", { staticClass: "fi-telephone mr-2" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("contact_modal.contact_title")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("contact_modal.address"),
                                      "label-for": "AdressInput",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "AdressInput",
                                        type: "text",
                                        required: "",
                                      },
                                      model: {
                                        value: _vm.record.address,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.record, "address", $$v)
                                        },
                                        expression: "record.address",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.phone"
                                              ),
                                              "label-for": "PhoneInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "PhoneInput",
                                                type: "text",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.record.phone,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "phone",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.phone",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.email"
                                              ),
                                              "label-for": "EmailInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "EmailInput",
                                                type: "email",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.record.email,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.email",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.facebook"
                                              ),
                                              "label-for": "FacebookInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "FacebookInput",
                                                type: "text",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.record.facebook,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "facebook",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.facebook",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.instagram"
                                              ),
                                              "label-for": "InstagramInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "InstagramInput",
                                                type: "text",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.record.instagram,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "instagram",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.instagram",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.twitter"
                                              ),
                                              "label-for": "TwitterInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "TwitterInput",
                                                type: "text",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.record.twitter,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "twitter",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.twitter",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12", md: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "contact_modal.snapchat"
                                              ),
                                              "label-for": "SnapchatInput",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "SnapchatInput",
                                                type: "text",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.record.snapchat,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.record,
                                                    "snapchat",
                                                    $$v
                                                  )
                                                },
                                                expression: "record.snapchat",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        ref: "bookings",
                        staticClass: "mb-3 section-card",
                        attrs: { "no-body": "", id: "bookings" },
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-2 border-bottom-0 text-left",
                            attrs: { "header-tag": "header", role: "tab" },
                          },
                          [
                            _c("i", { staticClass: "fi-calendar mr-2" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("contact_modal.trips_title")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-card-body", [
                          _vm.isRequesting
                            ? _c(
                                "div",
                                [
                                  _c("b-spinner", {
                                    attrs: { label: "Loading..." },
                                  }),
                                ],
                                1
                              )
                            : _vm.guestTabs.length < 1
                            ? _c("div", { staticClass: "text-center py-3" }, [
                                _c("p", { staticClass: "text-muted mb-0" }, [
                                  _c("i", {
                                    staticClass: "fi-info-circle mr-2",
                                  }),
                                  _vm._v(" No Guest History\n                "),
                                ]),
                              ])
                            : _c(
                                "div",
                                { staticClass: "booking-history" },
                                _vm._l(
                                  _vm.guestTabs,
                                  function (guestTab, index) {
                                    return _c(
                                      "b-card",
                                      {
                                        key: index,
                                        staticClass:
                                          "selected-result-card booking-card mb-2",
                                        attrs: { "bg-variant": "default" },
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c("b-col", [
                                              _vm._v(
                                                "Invoice #: " +
                                                  _vm._s(guestTab.id)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { staticClass: "card-icon" },
                                              [
                                                _vm._v(
                                                  "\n                      Sub Total:\n                      " +
                                                    _vm._s(
                                                      `${_vm.getVendor.local_currency} ${guestTab.stats.sub_total}`
                                                    ) +
                                                    "\n                      "
                                                ),
                                                _c("b-tooltip", {
                                                  attrs: {
                                                    target: "view-invoice",
                                                    placement: "top",
                                                    title:
                                                      "Navigate to Guest Tab Section",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fi fi-page-pdf large",
                                                  attrs: { id: "view-invoice" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goToPayments(
                                                        guestTab.id
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("hr"),
                                        _vm._v(" "),
                                        _vm.rooms_tabs.length == 0
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Restuarant Only Invoice\n                  "
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              _vm._l(
                                                _vm.rooms_tabs,
                                                function (room_tab, index) {
                                                  return _c(
                                                    "b-card-text",
                                                    { key: index },
                                                    [
                                                      room_tab.invoice_id ==
                                                      guestTab.id
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "b-row",
                                                                [
                                                                  _c("b-col", [
                                                                    _vm._v(
                                                                      " Unit: " +
                                                                        _vm._s(
                                                                          room_tab.name
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "right",
                                                                          "font-size":
                                                                            "14px",
                                                                        },
                                                                      attrs: {
                                                                        cols: "8",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            room_tab.description
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        ref: "notes",
                        staticClass: "section-card",
                        attrs: { "no-body": "", id: "notes" },
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-2 border-bottom-0 text-left",
                            attrs: { "header-tag": "header", role: "tab" },
                          },
                          [
                            _c("i", { staticClass: "fi-clipboard mr-2" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("contact_modal.notes_title")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-card-body", [
                          _vm.isRequesting
                            ? _c(
                                "div",
                                [
                                  _c("b-spinner", {
                                    attrs: { label: "Loading..." },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { "label-for": "guestNotes" } },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          id: "guestNotes",
                                          placeholder: _vm.$t(
                                            "contact_modal.new_note"
                                          ),
                                          rows: "2",
                                          type: "text",
                                        },
                                        model: {
                                          value: _vm.newGuestNote,
                                          callback: function ($$v) {
                                            _vm.newGuestNote = $$v
                                          },
                                          expression: "newGuestNote",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.top",
                                          value: "Add note to Profile",
                                          expression: "'Add note to Profile'",
                                          modifiers: { hover: true, top: true },
                                        },
                                      ],
                                      staticClass: "note-button",
                                      attrs: { variant: "outline-secondary" },
                                      on: { click: _vm.addGuestNote },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("contact_modal.add_note")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.guestNotes,
                                    function (guestNote, index) {
                                      return _c(
                                        "b-card",
                                        {
                                          key: index,
                                          staticClass: "note-card mb-2",
                                          attrs: { "bg-variant": "default" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Note Created: " +
                                                            _vm._s(
                                                              _vm.prettyDate(
                                                                guestNote.created_at
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c("i", {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.top",
                                                              value: "Remove",
                                                              expression:
                                                                "'Remove'",
                                                              modifiers: {
                                                                hover: true,
                                                                top: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "delete-icon float-right fi fi-x",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeGuestNote(
                                                                guestNote.id
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "b-card-text",
                                            { staticClass: "pre-line" },
                                            [_vm._v(_vm._s(guestNote.content))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("image-upload-modal", { ref: "upload-modal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }